import { css, cx } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"
import { css as cssFn } from "@emotion/react"
import LoadingOverlay from "@p-ban/common/src/components/overlay/LoadingOverlay/LoadingOverlay"

import type { MassProductionSimulationCourseResult } from "../../../../types/parsedResult"
import COLOR_CODE from "../../../constant/color"
import FirstPriceCell from "./FirstPriceCell"
import PriceCell from "./PriceCell"
import rowStyles from "./rowStyles"

import ellipsisImage from "./ellipsis.png"

const graySpinnerStyle = cssFn`
  filter: brightness(0) saturate(100%) invert(50%);
`

type Props = {
  title: string
  result: MassProductionSimulationCourseResult | null
  repeatOrderCount: number | null
  isLoading: boolean
  isCheaper: boolean
}

const Column = ({ title, result, repeatOrderCount, isLoading, isCheaper }: Props) => {
  const firstPrice = result?.firstPrice ?? null
  const initialCost = result?.initialCost ?? null
  const manufactureCost = result?.manufactureCost ?? null
  const repeatPrice = result?.repeatPrice ?? null
  const unitPrice = result?.unitPrice ?? null
  const grandTotalPrice = result?.grandTotalPrice ?? null

  return (
    <div className={styles.container}>
      {isLoading && <LoadingOverlay theme="light" spinnerStyle={graySpinnerStyle} />}
      <div className={cx(styles.title, rowStyles.title)}>{title}</div>
      <FirstPriceCell
        className={rowStyles.first}
        firstPrice={firstPrice}
        initialCost={initialCost}
        manufactureCost={manufactureCost}
        repeatPrice={repeatPrice}
        unitPrice={unitPrice}
      />
      {result && repeatOrderCount !== null && (
        <>
          {repeatOrderCount >= 2 && (
            <PriceCell className={rowStyles.total} currency={result.firstPrice + result.repeatPrice} />
          )}
          {repeatOrderCount >= 3 && (
            <PriceCell
              className={rowStyles.total}
              currency={result.firstPrice + result.repeatPrice + result.repeatPrice}
            />
          )}
        </>
      )}
      <div className={cx(rowStyles.ellipsis, styles.ellipsis)}>
        <Image src={ellipsisImage} alt="" />
      </div>
      <PriceCell
        className={cx(rowStyles.total, isCheaper && styles.redText)}
        currencyClassName={styles.total}
        currency={grandTotalPrice}
      />
    </div>
  )
}

export default Column

const styles = {
  container: css`
    position: relative;
    min-width: 310px;
  `,
  orangeText: css`
    color: ${COLOR_CODE.SIMULATION_TEXT_ORANGE};
  `,
  title: css`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    background-color: ${COLOR_CODE.SIMULATION_COURSE_GRAY};
  `,
  ellipsis: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  total: css`
    font-size: 18px;
    line-height: 18px;
  `,
  redText: css`
    color: ${COLOR_CODE.SIMULATION_RED};
  `,
}
